import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  ".NET Basics (C#, ASP.NET Core, MVC, APIs)",
  "Frontend (HTML5, CSS3, JavaScript, ReactJS/AngularJS, Bootstrap)",
  "Backend (Web API, EF Core, SQL Server, Azure Cosmos DB)",
  "Additional Topics (Microservices, Azure Functions, SignalR)",
  "Real Life, Industry Grade Projects",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 4 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];
const DotNetFullstack = () => (
  <CourseDetailTemplate title="DotNet Fullstack Development Course"
    description="Build your career in Fullstack Development with .NET! Master C#, ASP.NET Core, MVC, Web APIs, and modern frontend technologies to create enterprise-grade applications."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["C#", "ASP.NET Core", "ReactJS", "SQL Server", "Azure"]}
    programName="DotNet Fullstack Development Course"
  />
);
export default DotNetFullstack;
